import api from "./api";

/**
 * API: Retornar todas as inscrições dos eventos não encerrados
 */
export async function getAllInscricoesEventoAtivo() {
  try {
    const { data, status } = await api.get("/inscricao/evento-active");
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}
/**
 * API: Atualizar dados da inscrição do atleta
 */
type PropsEditInscricaoAtleta = {
  inscricaoId: number;
  eventoId: number;
  atleta_id: number;
  categoriaId: number;
  tamCam: string;
};
export async function editInscricaoAtleta(_data: PropsEditInscricaoAtleta) {
  try {
    const { data, status } = await api.patch("/inscricao", _data);
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

type PropsInscricaoCortesia = {
  inscricaoId: number;
  obs: string;
};
/**
 * API: Definir a inscrição como CORTESIA
 */
export async function setInscricaoCortesia(_data: PropsInscricaoCortesia) {
  const { data, status } = await api.put("/inscricao/cortesia", _data);
  return { data, status };
}

type PropsBaixaPayManual = PropsInscricaoCortesia;
/**
 * API: Definir baixa pagamento manual da inscrição
 * A inscrição será definida com status Pago, e o pagamento será efetuado manualmente
 */
export async function setBaixaPaymentoInscricao(_data: PropsBaixaPayManual) {
  try {
    const response = await api.put("/inscricao/baixa-manual-payment", _data);
    return { data: response.data, status: response.status };
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || "Falha na comunicação com o servidor.";
    return { error: errorMessage, status: error.response?.status || 500 };
  }
}

export async function cancelInscricao(inscricaoId: number) {
  try {
    const response = await api.patch(`/inscricao/cancel/${inscricaoId}`);
    return { data: response.data, status: response.status };
  } catch (error: any) {
    throw new Error(error.message);
  }
}
